import { UserEvents } from '../common';

var current;

var DomEventsBuilder = function DomEventsBuilder () {};

DomEventsBuilder.register = function register (userImplementation) {
    current = userImplementation;
};

DomEventsBuilder.create = function create (element, events) {
    var builder;

    if (current) {
        builder = current.create(element, events);
    } else {
        builder = new UserEvents(element, Object.assign({}, {multiTouch: true},

            events));
    }

    return builder;
};

export default DomEventsBuilder;
